module.exports = __webpack_public_path__ + "static/media/ww_hocs1.e3f2512e.gif";